import * as Actions from './actions.js'

// define initial state of all possible properties
export const initialState = {
  error: false,
  loading: true,
  reportData: null,
  sharing: false,
  sharingError: false,
  loadingAuditLog: false,
  auditLog: null,
  auditLogError: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_REPORT:
      return {
        ...state,
        loading: true,
        reportData: null
      }
    case Actions.GET_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        reportData: action.reportContents
      }
    case Actions.GET_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case Actions.GET_HTML_REPORT:
      return {
        ...state,
        loadingHtml: true
      }
    case Actions.GET_HTML_REPORT_SUCCESS:
      return {
        ...state,
        loadingHtml: false,
        reportHtml: action.reportHtml
      }
    case Actions.GET_HTML_REPORT_FAILURE:
      return {
        ...state,
        loadingHtml: false,
        error: action.error
      }
    case Actions.SHARE_REPORT:
      return {
        ...state,
        sharing: true
      }
    case Actions.SHARE_REPORT_SUCCESS:
      return {
        ...state,
        sharing: false,
        sharingError: false
      }
    case Actions.SHARE_REPORT_FAILURE:
      return {
        ...state,
        sharing: false,
        sharingError: true
      }
    case Actions.GET_AUDIT_LOG:
      return {
        ...state,
        loadingAuditLog: true
      }
    case Actions.GET_AUDIT_LOG_SUCCESS:
      return {
        ...state,
        loadingAuditLog: false,
        auditLog: action.auditLog,
        auditLogError: false
      }
    case Actions.GET_AUDIT_LOG_FAILURE:
      return {
        ...state,
        loadingAuditLog: false,
        auditLogError: true
      }
    default:
      return state
  }
}
